var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsIn, IsInt, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { BookmarkTypeValues } from './bookmark-type';
/**
 * Affected endpoints
 * POST /manfredite/bookmarks/<id>
 * PUT /manfredite/bookmarks/<id>
 */
export class BookmarkUpdateRequest {
}
__decorate([
    Expose(),
    IsIn(BookmarkTypeValues),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "type", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "title", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "category", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "author", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsString(),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "description", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsInt(),
    __metadata("design:type", Number)
], BookmarkUpdateRequest.prototype, "imageId", void 0);
__decorate([
    Expose(),
    IsUrl({ require_protocol: true }),
    MaxLength(255),
    IsOptional(),
    __metadata("design:type", String)
], BookmarkUpdateRequest.prototype, "url", void 0);
//# sourceMappingURL=bookmark-update.request.js.map